import { getAccountData } from './account-api';
import { setCookie } from '../../utils/cookie-utils';
import { sha256 } from '../../utils/sha-256';

/* eslint-disable no-console */
// The logged-in user id now lives in the server-side session and is rendered into
// the page as window.serverUserId / window.serverIsAuthenticated. This keeps the
// runtime globals in sync after a client-side login without using a cookie.
const setCookieValue = (userId) => {
  window.userId = parseInt(userId, 10);
  window.isAuthenticated = true;
};

const getLoggedInStatus = () => window.serverIsAuthenticated === true;

const getUserId = () => {
  const id = parseInt(window.serverUserId, 10);
  return Number.isNaN(id) ? -1 : id;
};

const getEmail = () => new Promise((resolve) => {
  getAccountData((data) => {
    const { username } = data;

    if (!username) {
      resolve(null);
      return;
    }

    const hashed = sha256(username);

    window.dataLayer.push({ user_email: hashed });

    // TODO / DEPRECATED: Don't set a cookie. Currently used in GTM for Epsilon
    setCookie('user_email', hashed, 30);
  });
});

const getPhoneNumber = () => new Promise((resolve) => {
  getAccountData((data) => {
    // Trim and remove non-digits (e.g. '-') from the number.
    let phoneNumber = data['phone-number'].trim().replace(/\D/g, '');

    if (phoneNumber.length === 10) {
      phoneNumber = `+1${phoneNumber}`;
    } else if (phoneNumber.length === 11) {
      phoneNumber = `+${phoneNumber}`;
    }

    if (!phoneNumber) {
      resolve(null);
      return;
    }

    const hashed = sha256(phoneNumber);

    window.dataLayer.push({ phone_number: hashed });
  });
});

const getDigitalUserId = () => {
  const { sessionStorage, userId } = window;
  const digitalUserStr = sessionStorage.getItem('grbr_userId');
  let digitalUserId = userId;
  if (digitalUserStr) {
    digitalUserId = JSON.parse(digitalUserStr).userId;
  }
  if (isNaN(digitalUserId)) { /* eslint-disable-line no-restricted-globals */
    digitalUserId = '';
  }
  return digitalUserId;
};

export {
  getDigitalUserId,
  getLoggedInStatus,
  getUserId,
  getEmail,
  getPhoneNumber,
  setCookieValue,
};
/* eslint-enable no-console */
